import consumer from "@/channels/consumer";
import { DashboardChart } from "@/components/dashboard-chart";
import { RecentSales } from "@/components/recent-sales";
import { SectionCards } from "@/components/section-cards";
import { SellerRanking } from "@/components/seller-ranking";
import type { DashboardProps } from "@/types/dashboard";
import { UserRole } from "@/types/user-role";
import { Head, router, usePage } from "@inertiajs/react";
import { useEffect } from "react";

export default function Show({
  metrics,
  chartData,
  sellerRanking,
  recentSales,
}: DashboardProps) {
  const { organization, user } = usePage().props;
  const isMember = user?.role === UserRole.MEMBER;

  useEffect(() => {
    if (!organization?.id) return;

    const subscription = consumer.subscriptions.create(
      { channel: "DashboardChannel", organization_id: organization.id },
      {
        received() {
          router.reload({ only: ["metrics", "chartData", "sellerRanking", "recentSales"] });
        },
      },
    );

    return () => {
      subscription.unsubscribe();
    };
  }, [organization?.id]);

  return (
    <div className="flex flex-col gap-4">
      <Head title="Dashboard" />
      <SectionCards metrics={metrics} isMember={isMember} />
      <DashboardChart data={chartData} />
      <div className="grid grid-cols-1 gap-4 @4xl/main:grid-cols-2">
        {!isMember && <SellerRanking sellerRanking={sellerRanking} />}
        <RecentSales recentSales={recentSales} isMember={isMember} fullWidth={isMember} />
      </div>
    </div>
  );
}
